import { sparkTheme as baseSparkTheme } from './spark';
import themeMerge from './theme-merge';

var overwriteMerge = function overwriteMerge(destinationArray, sourceArray, options) {
  return sourceArray;
};

export var createTheme = function createTheme(trustyleTheme, sparkTheme) {
  var themes = [baseSparkTheme, trustyleTheme];

  if (sparkTheme) {
    themes.push(sparkTheme);
  }

  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest && rest.length > 0) {
    themes.push.apply(themes, rest);
  }

  return themeMerge.all(themes, {
    arrayMerge: overwriteMerge
  });
};